import {Injectable} from '@angular/core';
import {MatPaginatorIntl} from '@angular/material/paginator';
import { BreakpointService } from '@services';

@Injectable()
export class CustomPaginator extends MatPaginatorIntl {
  constructor(
    private breakpointService: BreakpointService
  ) {
    super();
    this.nextPageLabel = 'Наступна сторінка';
    this.previousPageLabel = 'Попередня сторінка';
    this.itemsPerPageLabel = this.breakpointService.isMobile ? 'Елементів:' : 'Елементів на сторінці:';

    this.breakpointService.isMobile$.subscribe((isMobile) => {
      this.itemsPerPageLabel = isMobile ? 'Елементів:' : 'Елементів на сторінці:';
      this.changes.next();
    });

    this.getRangeLabel = function(page: number, pageSize: number, length: number) {
      if (!length || !pageSize) {
        return `0 з ${length}`;
      }

      length = Math.max(length, 0);

      const startIndex = page * pageSize;

      // If the start index exceeds the list length, do not try and fix the end index to the end.
      const endIndex = startIndex < length ?
        Math.min(startIndex + pageSize, length) :
        startIndex + pageSize;

      return `${startIndex + 1}–${endIndex} з ${length}`;
    };
  }
}
